export default {
  inserted(el, binding) {},
  bind(el, binding) {
    if (el.dataset.hide) {
      el.style.opacity = 0
      el.style.transition = 'opacity .2s ease-in'
    }
    if (el.dataset.src || el.dataset.defaultSrc) {
      const img = new Image()
      img.src = el.dataset.src || el.dataset.defaultSrc
      img.onload = function () {
        el.style.backgroundImage = `url(${img.src})`
        setTimeout(() => {
          el.style.opacity = 1
        }, 60)
      }
      img.onerror = (err) => {
        console.error('Image load error', err)
        if (el.dataset.defaultSrc && el.src !== el.dataset.defaultSrc) {
          el.style.backgroundImage = `url(${el.dataset.defaultSrc})`
          setTimeout(() => {
            el.style.opacity = 1
          }, 60)
        }
      }
    }
  },
  update(el, binding) {
    if (el.dataset.src) {
      const img = new Image()
      img.src = el.dataset.src
      img.onload = () => {
        el.style.backgroundImage = `url(${img.src})`
        setTimeout(() => {
          el.style.opacity = 1
        }, 60)
      }
      img.onerror = (err) => {
        console.error('Image load error', err)
        if (el.dataset.defaultSrc && el.src !== el.dataset.defaultSrc) {
          el.style.backgroundImage = `url(${el.dataset.defaultSrc})`
          setTimeout(() => {
            el.style.opacity = 1
          }, 60)
        }
      }
    }
  }
}
